import { Field } from "../../HtmlEditor/Extensions/Field";

export const FieldMarkdown = Field.extend({
  addStorage() {
    return {
      markdown: {
        serialize(state: { write: (text: string) => void }, node: { attrs: { field: string } }) {
          state.write(`{{${node.attrs.field}}}`);
        }
      }
    };
  }
});
